import { FormProvider } from 'react-hook-form';

import { FormLayout } from '../../components/FormLayout';
import { TitleForm } from '../../components/TitleForm';
import { Content } from '../../components/Content';
import { useCalculatorForm, useGetEnrichedScheme } from '../../hooks';
import { useState } from 'react';

export const Form: React.FC = () => {
  const formScheme = useGetEnrichedScheme();
  const [formRef, setFormRef] = useState<HTMLFormElement | null>(null);
  const { reactHookForm, validateOnBlurHandler } = useCalculatorForm(formScheme, formRef);

  return (
    <FormProvider {...reactHookForm}>
      <FormLayout>
        <form onBlur={validateOnBlurHandler} ref={node => setFormRef(node)}>
          <TitleForm level={1}>Ипотечный калькулятор</TitleForm>
          <Content elements={formScheme} data-testid="form-content" />
        </form>
      </FormLayout>
    </FormProvider>
  );
};

Form.displayName = 'Form';
